import React, { useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import DraggableElement from './DraggableElement';
import { Card, CardBody } from 'reactstrap';
import { Image } from '../../../AbstractElements';
import { dynamicImage } from '../../../Service';
import { ExtFile } from '@dropzone-ui/react';
import { PageFile } from './ReportCreator';

interface CanvasAreaProps {
  elements: Element[];
  setElements: (elements: Element[]) => void;
  setSelectedElement: (element: Element) => void;
  pageFiles: PageFile[];
  selectedElement: Element | null;
}

interface Element {
  id: number;
  type: string;
  subject: string;
  description: string;
  file_id?: string;
}

const CanvasArea: React.FC<CanvasAreaProps> = ({ pageFiles, selectedElement, elements, setElements, setSelectedElement }) => {
  const moveElement = (dragId: number, hoverId: number | undefined) => {
    const dragIndex = elements.findIndex(el => el.id === dragId);
    const hoverIndex = elements.findIndex(el => el.id === hoverId);

    if (dragIndex === -1 || hoverIndex === -1) {
      return; // Ensure valid indices
    }
    const newElements = [...elements];
    const dragElement = newElements[dragIndex];
    newElements.splice(dragIndex, 1);
    newElements.splice(hoverIndex, 0, dragElement);

    setElements(newElements);
  };


  const [, drop] = useDrop({
    accept: 'element',
    hover(item: Element, monitor) {
      const dragId = item.id;
      const hoverId = elements.find(el => el.id === monitor.getItem().id)?.id;
      if (!hoverId || dragId === hoverId) {
        return;
      }

      moveElement(dragId, hoverId);
      item.id = hoverId; // Update the id for performance optimization
    },
    drop(item: Element, monitor) {
      const dragId = item.id;
      const dropTarget = monitor.getClientOffset();

      // Find the closest element in elements array where drop occurred
      const hoverElement = elements.find(el => {
        const element = document.getElementById(`element-${el.id}`);

        // Check if element is not null before accessing its properties
        if (element) {
          const elementRect = element.getBoundingClientRect();
          return dropTarget && dropTarget.x >= elementRect.left && dropTarget.x <= elementRect.right &&
            dropTarget.y >= elementRect.top && dropTarget.y <= elementRect.bottom;
        }

        return false; // If element is null, return false
      });

      // Finalize the position swap only on drop, checking that we're not swapping an element with itself
      if (hoverElement && dragId !== hoverElement.id) {
        moveElement(dragId, hoverElement.id);
      }
    }

  });

  return (
    <div ref={drop} style={{ width: '100%', position: 'relative', overflow: 'auto' }}>
      <Card className='canvas-area ' style={{ background: "black", maxWidth: 600, marginInline: "auto" }} >
        <CardBody
          className="pb-5"
          style={{ overflow: "auto", maxWidth: "100%", minHeight: "calc(100vh - 200px)" }}
        >
          <div>
            <div className='d-flex justify-content-center my-4'>
              <Image className="img-fluid for-light" src={dynamicImage("logo/logo.png")} alt="logo" style={{ width: "25%" }} />
            </div>
            {elements.map((element, index) => (
              <DraggableElement pageFiles={pageFiles} key={element.id} element={element} selectedElement={selectedElement} index={index} setSelectedElement={setSelectedElement} />
            ))}
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default CanvasArea;
